import { defaultAxios, IParams } from './base';

export interface IFetchCommonCodes extends IParams {
  codeGrpCd?: string;
  codeGrpCdList?: string[];
}

export const fetchCommonCodes = (params: IFetchCommonCodes) => {
  return defaultAxios().post(`/cmm/codeList`, params);
};
